import axios from "./configs/axiosConfig";

export const getDealerOnboardList = async () => {
  const url = `/dealeronboard`;
  return await axios.get(url);
};


export const searchVWOnboardedDealer = async (key) => {
  const url = `dealeronboard/search?key=${key}`;
  return await axios.get(url);
};